
const terminalSettingsUtils = require('./terminalSettingsUtils');
const stringUtil = require('../../string/stringUtil');

module.exports.getSignatureCardAllowed = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getControlSettings().signatureCardAllowed))
        return false;

    return terminalSettingsUtils.getControlSettings().signatureCardAllowed;
}

module.exports.setSignatureCardAllowed = function(signatureCardAllowed)
{
    terminalSettingsUtils.getControlSettings().signatureCardAllowed = signatureCardAllowed;
    terminalSettingsUtils.saveSettings();
}

module.exports.getAllowOpenItems = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getControlSettings().allowOpenItems))
        return false;

    return terminalSettingsUtils.getControlSettings().allowOpenItems;
}

module.exports.setAllowOpenItems = function(allowOpenItems)
{
    terminalSettingsUtils.getControlSettings().allowOpenItems = allowOpenItems;
    terminalSettingsUtils.saveSettings();
}

module.exports.getAllowOpenDiscounts = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getControlSettings().allowOpenDiscounts))
        return false;

    return terminalSettingsUtils.getControlSettings().allowOpenDiscounts;
}

module.exports.setAllowOpenDiscounts = function(allowOpenDiscounts)
{
    terminalSettingsUtils.getControlSettings().allowOpenDiscounts = allowOpenDiscounts;
    terminalSettingsUtils.saveSettings();
}

module.exports.getLogoutAfterEachOrder = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getControlSettings().logoutAfterEachOrder))
        return true;

    return terminalSettingsUtils.getControlSettings().logoutAfterEachOrder;
}

module.exports.setLogoutAfterEachOrder = function(logoutAfterEachOrder)
{
    terminalSettingsUtils.getControlSettings().logoutAfterEachOrder = logoutAfterEachOrder;
    terminalSettingsUtils.saveSettings();
}

module.exports.getLogoutAfterIdle = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getControlSettings().logoutOnIdle))
        return true;

    return terminalSettingsUtils.getControlSettings().logoutOnIdle;
}

module.exports.setLogoutAfterIdle = function(logoutOnIdle)
{
    terminalSettingsUtils.getControlSettings().logoutOnIdle = logoutOnIdle;
    terminalSettingsUtils.saveSettings();
}

module.exports.getAllowAllStorefronts = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getControlSettings().allowAllStorefronts))
        return true;

    return terminalSettingsUtils.getControlSettings().allowAllStorefronts;
}

module.exports.setAllowAllStorefronts = function(allowAllStorefronts)
{
    terminalSettingsUtils.getControlSettings().allowAllStorefronts = allowAllStorefronts;
    terminalSettingsUtils.saveSettings();
}

module.exports.getAllowItemsFromMultipleStorefronts = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getControlSettings().allowItemsFromMultipleStorefronts))
        return true;

    return terminalSettingsUtils.getControlSettings().allowItemsFromMultipleStorefronts;
}

module.exports.setAllowItemsFromMultipleStorefronts = function(allowItemsFromMultipleStorefronts)
{
    terminalSettingsUtils.getControlSettings().allowItemsFromMultipleStorefronts = allowItemsFromMultipleStorefronts;
    terminalSettingsUtils.saveSettings();
}

module.exports.getMandatoryDetailsBeforeOrderDetails = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getControlSettings().mandatoryDetailsBeforeOrderDetails))
        return true;

    return terminalSettingsUtils.getControlSettings().mandatoryDetailsBeforeOrderDetails;
}

module.exports.setMandatoryDetailsBeforeOrderDetails = function(mandatoryDetailsBeforeOrderDetails)
{
    terminalSettingsUtils.getControlSettings().mandatoryDetailsBeforeOrderDetails = mandatoryDetailsBeforeOrderDetails;
    terminalSettingsUtils.saveSettings();
}


module.exports.getPrintDraftSaleReceipt = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getControlSettings().printDraftSaleReceipt))
        return false;

    return terminalSettingsUtils.getControlSettings().printDraftSaleReceipt;
}

module.exports.setPrintDraftSaleReceipt = function(printDraftSaleReceipt)
{
    terminalSettingsUtils.getControlSettings().printDraftSaleReceipt = printDraftSaleReceipt;
    terminalSettingsUtils.saveSettings();
}
